import React from 'react'
import PropType from 'prop-types'
import { Link } from 'react-router-dom'

function UserItem({user: {login, avatar_url }}) {
  return (
    <div className="card shadow-md compact side bg-base-200">
        <div className="border-current flex-row item-center space-x-4 card-body">
            <div>
                <div className="avatar">
                    <div className="rounded-full shadow w-14 h-14">
                        <img src={avatar_url} alt="Profile" />
                    </div>
                </div>
            </div>
            <div>
                <h2  className="card-title">{login}</h2>
                <Link to={
                    `/user/${login}`
                } className="text-base-content text-opacity-80">Visit Profile</Link>
            </div>
        </div>
    </div>
  )
}

UserItem.PropType = {
    user : PropType.object.isRequired,
}

export default UserItem